/** Xtram brand orange — used for current-screen F-key hints */
export const XTRAM_ORANGE = '#F9AA2A';

/** Keyboard shortcut for navigate back */
export const BACK_FUNCTION_KEY = 'F11';

/**
 * Returns the F-key shortcut for the current client screen (e.g. F1 for Incomes), or null.
 */
export function getScreenFunctionKey(pathname, type) {
    const currentPath = (pathname || '').toLowerCase();
    const currentType = type;

    if (currentPath.startsWith('/document') && currentType === 'Incomes') return 'F1';
    if (currentPath.startsWith('/document') && currentType === 'Expenses') return 'F2';
    if (currentPath.startsWith('/paymentacceptance')) return 'F3';
    if (currentPath.startsWith('/journalentry')) return 'F4';
    if (currentPath.startsWith('/profitandlossreport')) return 'F5';
    if (currentPath.startsWith('/ledgerreport') && currentType === 'TrialBalance') return 'F6';
    if (currentPath.startsWith('/ledgerreport') && currentType === 'ReportDetailedProfitAndLoss') return 'F7';
    if (currentPath.startsWith('/accountcardstable')) return 'F8';
    if (currentPath.startsWith('/accountcarddashboard')) return 'F9';
    if (currentPath.startsWith('/accountant-details')) return 'F10';
    return null;
}
